export default "__VITE_ASSET__CWIQzcNn__"